import{styleHookSingleton as r}from"./hook.js";var n=function(){var n=r();return function(r){var o=r.styles;return n(o),null}};export{n as styleSingleton};
